export class PaginationBaseValueConverter {
    toView(pageCountTotal: number, configuration: Object) {

        //
        let half = Math.round(configuration['pageCountShow'] / 2) - 1;

        //
        if (pageCountTotal < configuration['pageCountShow'])
            return this.GetPages(0, pageCountTotal + 1, configuration['pageIndex'], configuration['side']);

        //
        else if (configuration['pageIndex'] >= 0 && configuration['pageIndex'] < half)
            return this.GetPages(0, configuration['pageCountShow'], configuration['pageIndex'], configuration['side']);

        //
        else if (configuration['pageIndex'] >= (pageCountTotal - half))
            return this.GetPages((pageCountTotal - configuration['pageCountShow'] + 1), pageCountTotal + 1, configuration['pageIndex'], configuration['side']);

        //
        else
            return this.GetPages((configuration['pageIndex'] - half), configuration['pageCountShow'] + (configuration['pageIndex'] - half), configuration['pageIndex'], configuration['side']);
    }

    private GetPages(start: number, length: number, pageIndex: number, side: string): Array<number> {

        //
        let pages: Array<number> = [];

        //
        for (var i = start; i < length; i++) {
            if (side === 'left' && i < pageIndex) {
                pages.push(i);
            }
            else if (side === 'right' && i > pageIndex) {
                pages.push(i);
            }
        }

        //
        return pages;
    }
}